import { render, staticRenderFns } from "./MultiPayment.vue?vue&type=template&id=30ad5a1a&"
import script from "./MultiPayment.vue?vue&type=script&lang=js&"
export * from "./MultiPayment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports